import {
  Box,
  VStack,
  Input,
  FormControl,
  FormLabel,
  Button,
  Text,
  Heading,
  Textarea,
  InputGroup,
  InputLeftElement,
  Flex,
  Spinner,
  useToast,
} from "@chakra-ui/react";
import { useState, useRef, Fragment, useEffect } from "react";
import { DeleteIcon } from "@chakra-ui/icons";
import uploadFile from "./../../assets/upload-file.svg";
import { useNavigate } from "react-router-dom";
import { TARM_AWS_URL } from "../../api/api";
import { getRunID } from "../../util/runID";
import axios from "axios";
import { Select } from "chakra-react-select";
import JobProfileName from "./JobProfileName";
import RequiredJobTitle from "./RequiredJobTitle.js/RequiredJobTitle";
import Loading from "../Loading/Loading";

const CreateJobProfile = () => {
  const inputRef = useRef();
  const navigate = useNavigate();
  const [source] = useState(axios.CancelToken.source());
  const [jobProfileName, setJobProfileName] = useState("");
  const [isJobProfileNameAvailable, setIsJobProfileNameAvailable] = useState(true);
  const [jdFileUpload, setJdFileUpload] = useState("");
  const [mandatorySkills, setMandatorySkills] = useState("");
  const [optionalSkills, setOptionalSkills] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const [selectedJobProfiles, setSelectedJobProfiles] = useState([]);
  const [allJobProfiles, setAllJobProfiles] = useState([]);
  const [requiredJobTitle, setRequiredJobTitle] = useState([])
  const toast = useToast();

  useEffect(() => {
    fetchJds()
    return () => {
      if (source) {
        source.cancel();
      }
    };
  }, []);

  const fetchJds = async () => {
    try {
      const response = await TARM_AWS_URL.get('jd-parser/get-db-items?identifier=jds', {
        cancelToken: source.token,
      });
      setAllJobProfiles(response.data);
    } catch (error) {
      handleError(error);
    } finally {
      setIsLoading(false); // Stop loading after fetching
    }
  };

  const handleError = (error) => {
    console.error(error); // Log error to console for debugging
    toast({
      title: error.message,
      status: "error",
      duration: 3000,
      isClosable: true,
    });
  };

  const handleSelectJobProfile = (selectedItems) => {
    setSelectedJobProfiles(selectedItems);
    console.log(selectedItems);
    console.log(window.location.href);
    let path = window.location.href + "/edit-ext-jd/" + selectedItems.run_id;
    window.open(path, "_blank");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    jdFileUpload ? uploadJdHandler() : mandatoryOptionalSkillsHandler();
  };

  const uploadJdHandler = async () => {
    setIsBtnLoading(true);
    console.log(jdFileUpload);
    const run_id = getRunID();
    const filename = jdFileUpload.name
    try {
      const response = await TARM_AWS_URL.get("jd-parser/upload-jd", {
        params: {
          run_id: run_id,
          filename: filename
        }
      },
        {
          cancelToken: source.token,
        });
      console.log(response)
      const responseData = response.data
      const fields = responseData.fields
      const url = responseData.url
      if (response.status === 200) {
        const formData = new FormData();
        formData.append('AWSAccessKeyId', fields.AWSAccessKeyId)
        formData.append('key', fields['key'])
        formData.append('policy', fields['policy'])
        formData.append('signature', fields['signature'])
        formData.append('x-amz-security-token', fields['x-amz-security-token'])
        formData.append("file", jdFileUpload)
        const response = await axios.post(url, formData, { cancelToken: source.token })
        console.log(response)
        toast({
          title: "JD Uploaded Successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
        })
        if (response.status === 204) {
          const response1 = await TARM_AWS_URL.get("jd-parser/extract-text", {
            params: {
              run_id: run_id,
              filename: filename
            }
          },
            {
              cancelToken: source.token,
            });
          console.log(response1);
          toast({
            title: "JD Extraction Completed",
            status: "success",
            duration: 3000,
            isClosable: true,
          })
          const response2 = await TARM_AWS_URL.get("jd-parser/parse-jd", {
            params: {
              run_id: run_id,
              filename: filename
            }
          },
            {
              cancelToken: source.token,
            });
          console.log(response2);
          if (response2.status === 200) {
            toast({
              title: "JD Parsing Started",
              status: "success",
              duration: 10000,
              isClosable: true,
            })
            const response3 = await TARM_AWS_URL.get("jd-parser/enrich-jd-skills", {
              params: {
                run_id: run_id,
                filename: filename
              }
            },
              {
                cancelToken: source.token,
              });
            console.log(response3);
            // setProgressValue(100)
            const data = response3.data
            navigate("skills-selector", {
              state: {
                run_id: run_id,
                filename: filename,
                jobProfileName: jobProfileName,
                requiredJobTitles: data.RequiredJobTitles,
                mandatorySkillsTreeData: data.MandatorySkillsTreeData,
                optionalSkillsTreeData: data.OptionalSkillsTreeData,
                mandatorySkills: data.MandatorySkills,
                optionalSkills: data.OptionalSkills
              },
            });
          }
        }
      }
    } catch (error) {
      console.log(`Error: ${error.message}`);
      toast({
        title: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsBtnLoading(false);
    }
  };

  const stringToArray = (str) => str.split(',').map(string => string.trim()).filter(str => str)

  const mandatoryOptionalSkillsHandler = async () => {
    setIsBtnLoading(true);
    try {
      const run_id = getRunID();
      const postBody = {
        "run_id": run_id,
        "MandatorySkills": stringToArray(mandatorySkills),
        "OptionalSkills": stringToArray(optionalSkills),
        "RequiredJobTitles": requiredJobTitle.map(jp => jp.text)
      }
      console.log(JSON.stringify(postBody))
      const response = await TARM_AWS_URL.post("jd-parser/extractfromtext", postBody, {
        cancelToken: source.token,
      });
      console.log(response);
      const data = response.data
      navigate("skills-selector", {
        state: {
          run_id: run_id,
          filename: run_id, // as there is no jd upload, we will use run_id as filename
          jobProfileName: jobProfileName,
          requiredJobTitles: data.RequiredJobTitles,
          mandatorySkillsTreeData: data.MandatorySkillsTreeData,
          optionalSkillsTreeData: data.OptionalSkillsTreeData,
          mandatorySkills: data.MandatorySkills,
          optionalSkills: data.OptionalSkills
        },
      });
    } catch (error) {
      console.log(`Error: ${error.message}`);
      toast({
        title: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsBtnLoading(false);
    }
  };

  return isLoading ? (
    <Loading loading={isLoading} />) : (
    <VStack>
      <Heading>Create a job profile</Heading>
      <br />
      <Box borderWidth="3px" borderRadius="lg" p="10" width="555px">
        <form onSubmit={handleSubmit}>
          <FormControl isRequired>
            <FormLabel htmlFor="jobProfiles">
              Select and edit from existing job profiles
            </FormLabel>
            <Select
              id="jobProfiles"
              name="jobProfiles"
              options={allJobProfiles.map((jp) => ({
                label: jp.PK,
                value: jp.PK,
                run_id: jp.run_id,
              }))}
              value={selectedJobProfiles}
              onChange={handleSelectJobProfile}
              placeholder="Search"
              closeMenuOnSelect={true}
            />
          </FormControl>

          <Text fontSize="small" textAlign="center" mt={4}>
            Or create a new by uploading jd file
          </Text>

          <JobProfileName
            getIsJobProfileNameAvailable={setIsJobProfileNameAvailable}
            getJobProfileName={setJobProfileName}
          />

          {/* if mandatorySkills has some value, then don't show jdFileUpload*/}
          {!mandatorySkills && (
            <Fragment>
              <FormControl mt={4} isRequired>
                <FormLabel htmlFor="jdFileUpload">
                  Upload job description file (accepts .pdf .docx)
                </FormLabel>
                <InputGroup>
                  <InputLeftElement pointerEvents="none">
                    <img
                      style={{ height: "22px" }}
                      src={uploadFile}
                      alt="Upload File"
                    />
                  </InputLeftElement>
                  <input
                    type="file"
                    onChange={(e) => setJdFileUpload(e.target.files[0])}
                    accept=".pdf, .docx"
                    name={jdFileUpload ? jdFileUpload.name : ""}
                    ref={inputRef}
                    style={{ display: "none" }}
                  />
                  <Input
                    id="jdFileUpload"
                    placeholder="Upload job description file"
                    onClick={() => inputRef.current.click()}
                    className="cursor-pointer"
                    readOnly={true}
                    value={(jdFileUpload && jdFileUpload.name) || ""}
                  />
                </InputGroup>
              </FormControl>

              {jdFileUpload && (
                <Box p="2">
                  <Flex justify="space-between">
                    <Text>{jdFileUpload.name}</Text>
                    <DeleteIcon
                      mt={1}
                      color="gray"
                      className="cursor-pointer close-icon"
                      onClick={(e) => {
                        setJdFileUpload("");
                        inputRef.current.value = "";
                      }}
                    />
                  </Flex>
                </Box>
              )}
            </Fragment>
          )}

          {/* if jdFileUpload || mandatorySkills has some value, then don't OR text*/}
          {!(jdFileUpload || mandatorySkills) && (
            <Text fontSize="small" textAlign="center" mt={4}>
              Or create by entering skills
            </Text>
          )}

          {/* if jdFileUpload has some value, then don't show mandatorySkills*/}
          {!jdFileUpload && (
            <>
              <FormControl isRequired mt={4}>
                <FormLabel htmlFor="mandatorySkills">
                  Enter mandatory skills
                </FormLabel>
                <Textarea
                  id="mandatorySkills"
                  type="text"
                  value={mandatorySkills}
                  onChange={(e) => setMandatorySkills(e.target.value)}
                />
              </FormControl>
              <FormControl mt={4}>
                <FormLabel htmlFor="optionalSkills">
                  Enter optional skills
                </FormLabel>
                <Textarea
                  id="optionalSkills"
                  type="text"
                  value={optionalSkills}
                  onChange={(e) => setOptionalSkills(e.target.value)}
                />
              </FormControl>
              <FormControl mt={4} isRequired>
                <FormLabel>
                  Enter required job titles
                </FormLabel>
                <RequiredJobTitle tags={requiredJobTitle} setTags={setRequiredJobTitle} />
              </FormControl>
            </>
          )}

          <Box textAlign="end" mt="4">
            <Button
              type="submit"
              colorScheme="blue"
              mr={2}
              disabled={
                !(jobProfileName && (jdFileUpload || (mandatorySkills && requiredJobTitle.length > 0))) ||
                isBtnLoading ||
                !isJobProfileNameAvailable
              }
            >
              {isBtnLoading && <Spinner size="sm" mr={2} />}
              Next
            </Button>
          </Box>
        </form>
      </Box>
    </VStack>
  );
};

export default CreateJobProfile;
